import {ROLE} from './api'
import {METHOD, request} from '@/utils/request'

export async function getAll() {
  return request(ROLE+"/getAll", METHOD.GET)
}

export async function save(params) {
  return request(ROLE+"/insert", METHOD.POST, params)
}

export async function update(params) {
  return request(ROLE+"/updateById", METHOD.POST, params)
}

export async function deleteById(params) {
  return request(ROLE+"/deleteById?id="+params.id, METHOD.DELETE)
}

export default {getAll,save,update,deleteById}